import { NextPage, GetStaticProps } from 'next';
import TopBooks from '@/components/screens/top/top-books/TopBooks';
import { API_URL, REVALIDATE_TIME } from '@/helpers/variables';

import { ITop100Books } from '@/interfaces/top100Books.interface';

interface ITopBooksPage {
  topData: ITop100Books;
}

const TopBooksPage: NextPage<ITopBooksPage> = ({ topData }) => {
  return <TopBooks topData={topData} />;
};

export const getStaticProps: GetStaticProps = async () => {
  const topDataRest = await fetch(`${API_URL}satellite/books/top`);
  const topData = await topDataRest.json();

  return { props: { topData }, revalidate: REVALIDATE_TIME };
};

export default TopBooksPage;
